const getters = {
  language: state => state.app.language,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  id: state => state.user.id,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  timezone: state => state.user.timezone,
  roles: state => state.user.roles,
  notReviews: state => state.user.notReviews,
  score: state => state.user.score,
  setting: state => state.user.setting,
  subjectType: state => state.user.subjectType
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js